site.stickyHead = {
	init:function() {
		var lastScroll = 0;
		window.addEventListener('scroll', function(e){
			var distanceY = window.pageYOffset || document.documentElement.scrollTop,
				shrinkOn = 50;
			if (distanceY > shrinkOn) {
				setTimeout(function() {
					$('body').addClass('stickyHead');
				}, 400);
			} else {
				$('body').removeClass('stickyHead');
			}

			var scroll = $(window).scrollTop();
			if(lastScroll - scroll > 0) {
				$('body').addClass('upscroll');
			} else {
				$('body').removeClass('upscroll');
			}
			if (scroll) {
				lastScroll = scroll;
			}
		});
	}
};

site.inits.push('site.stickyHead.init()');
